<template>
    <div class="external-invoice-table">
        <ahDataTable
            tableKey="tax-creadit-invoice-data-table"
            :columns="columns"
            :data="datas"
            :showRefreshButton="true"
            :indexStart="pageSize * (currPage - 1) + 1"
            v-loading="loading"
            @row-click="onClick"
            @refresh="$emit('refresh')"
        >
            <template v-slot:customNumber="scope">
                <div class="idx">{{ scope.row.customNumber }}</div>
            </template>
            <template v-slot:foo="scope">
                <ahReceiptNumber v-if="scope.row.foo" :v="scope.row.foo" />
                <span v-else>--</span>
            </template>
            <template v-slot:foO_DAT="scope">
                <span>{{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
            <template v-slot:nonTaxAmt="scope">
                <Money :v="scope.row.amt - scope.row.tax" />
            </template>
            <template v-slot:tax="scope">
                <Money :v="scope.row.tax" />
            </template>
            <template v-slot:description="scope">
                <span>{{ scope.row.description || "--" }}</span>
            </template>
            <template v-slot:crT_DAT="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </ahDataTable>
    </div>
</template>

<script>
import ahDataTable from '@/components/ui/ahDataTable.vue';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';

export default {
    components: { ahDataTable, ahReceiptNumber },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        year: {
            type: Number,
            default: 0,
        },
        phase: {
            type: Number,
            default: 0,
        },
        pageSize: {
            type: Number,
            default: 0,
        },
        currPage: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            columns: {
                index: {
                    label: '#',
                },
                customNumber: {
                    label: '系統編號',
                    width: 120,
                },
                foo: {
                    label: '發票號碼',
                    width: 130,
                    disableHide: false,
                },
                description: {
                    label: '摘要',
                    disableHide: false,
                },
                foO_DAT: {
                    label: '發票日期',
                    width: 133,
                },
                nonTaxAmt: {
                    label: '銷售額(未稅)',
                    width: 150,
                    align: 'right',
                },
                tax: {
                    label: '稅額',
                    width: 100,
                    align: 'right',
                },
                amt: {
                    label: '含稅總計',
                    width: 150,
                    align: 'right',
                },
                crT_USR: {
                    label: '填寫人',
                    width: 110,
                },
                crT_DAT: {
                    label: '建立日期',
                    width: 133,
                },
            },
        };
    },
    methods: {
        onClick({ sno }) {
            console.log(sno);
            this.$router.push({
                name: 'tax-credit-invoice-edit',
                params: { sno },
                query: { fromYear: this.year, fromPhase: this.phase },
            });
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
</style>
